// extracted by mini-css-extract-plugin
module.exports = {"container":"errorscreen_container__MUznh","content":"errorscreen_content__f0N8y","image":"errorscreen_image__1rPqC"};